import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import PageHeader from 'common/components/modules/page-header';
import LineLoader from 'common/components/elements/loader/line';
import CircleLoader from 'common/components/elements/loader/circle';
import cx from 'classnames';

class VideoUpload extends Component {
   static propTypes = {
      data: PropTypes.object,
      headerLeftIconAction: PropTypes.func,
   };

   render() {
      const { data: { uploading = 0, status = '' } = {}, headerLeftIconAction } = this.props;
      const statusNumber = {
         none: 0,
         pending: 1,
         progress: 2,
         generating_poster_images: 3,
         completed: 4,
      }
      const curentStatusNumber = statusNumber[status] ? statusNumber[status] : 0
      return (
         <div className='adminDashboard__videoUpload flex bg-panel flex-col h-full select-none'>
            <div >
               <PageHeader
                  title='Uploading...'
                  fontIconSize='doubleLarge'
                  fontIconColor='major'
                  leftIconName='close'
                  truncateHeaderText={ false }
                  leftIconAction={ headerLeftIconAction }
                  isFixed={ false }
               />
            </div>
            <div className='px-12 flex flex-col items-center m-5'>
               <div
                  className='rounded-lg relative overflow-hidden my-3 w-full h-full bg-placeholder flex flex-col items-center justify-center'
                  style={ { height: '320px', width: '268px' } }
               >
                  <CircleLoader color='major-dark' />
                  <p className='text-major-dark w-64 text-center mt-4' style={ { lineHeight: '16px' } }>
                     Please wait while your story is being uploaded</p>
               </div>
            </div>
            <div className='px-8 mb-12'>
               <div className='videoUpload__uploadingPart before:bg-success mt-2 pl-6'>
                  <div className='flex justify-between'>
                     <p className='leading-tight'>Uploading</p>
                     <p className={ `leading-tight text-${ uploading > 99 ? 'success' : 'placeholder' } ` }>{ uploading }%</p>
                  </div>
                  <div
                     className={ `${ uploading === 0 ? 'bg-grey-hover before:bg-grey-hover' : 'bg-success' } rounded-full max-w-full h-2 mt-1` }
                     style={ { width: `${ uploading === 0 ? '100' : uploading }%` } }
                  />
               </div>
               <div
                  className={ cx({
                     'mt-5 videoUpload__generatingPart pl-6 videoUpload__optimizingPart': true,
                     'before:bg-success': curentStatusNumber > 2,
                     'before:bg-action': curentStatusNumber === 2,
                     'before:bg-disabled': curentStatusNumber < 2,
                  }) }
               >
                  <div className='flex justify-between'>
                     <p className='leading-tight'>Optimizing</p>
                     {
                        curentStatusNumber === 2  && (
                           <p className='text-action leading-tight'>Progress</p>
                        )
                     }
                     {
                        curentStatusNumber > 2  && (
                           <p className='text-success leading-tight'>Completed</p>
                        )
                     }
                     {
                        curentStatusNumber < 2 && (
                           <p className='text-placeholder leading-tight'>Pending</p>
                        )
                     }
                  </div>
                  {
                     curentStatusNumber === 2 && (

                        <LineLoader className='h-2 mt-2' />
                     )
                  }
                  {
                     curentStatusNumber < 2 && (
                        <div className='rounded-full bg-grey-hover h-2 mt-2' />
                     )
                  }
                  {
                     curentStatusNumber > 2 && (
                        <div className='rounded-full bg-success h-2 mt-2' />
                     )
                  }
               </div>
            </div>
         </div>
      );
   }
}

export default VideoUpload;
